import { z } from 'zod';

const AddEmployeeSchema = z.object({
  id: z.number().or(z.string()),
  personnelNumber: z.string().or(z.number()),
  fullName: z.string()
});

export default AddEmployeeSchema;
